import React, { useState } from 'react'
import ReactTooltip from 'react-tooltip';
import * as yup from 'yup';
import { Formik } from 'formik';
import styles from './editQuizTemplate.module.scss';
import { Col, Container, Row, Form, Button, Modal } from 'react-bootstrap';
import QuizConfiguration from './quizConfiguration';
import CSSLoader from '../../../../../shared/cssLoader';
import Review from './review';


const EditQuizTemplate = (props) => {

    let [step, setStep] = useState(1);
    let [values, setValues] = useState({
        quizeName: props.data.name,
        quizSpecialization: props.data.specialization,
        subject_areas: props.data.subject_areas,
        subjectareaToBeAdded: '',
        subjectareasCount: 0,
        duration: props.data.duration,
        Description: props.data.description,
    });

    let [isLoading, setLoading] = useState(false);

    function nextPage(value) {
        setStep(value)
    }

    function previousPage(value) {
        setStep(value)
    }

    function setSubmitValues(values) {
        setValues((prevState) => ({
            ...prevState,
            quizeName: values.quizName,
            quizSpecialization: values.quizSpecialization,
            subject_areas: values.subject_areas,
            subjectareasCount: values.subjectareasCount,
            duration: values.duration,
            Description: values.Description,
        }))
    }
    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Edit Quiz Template</h2>
                    </div>

                    <Col xs={{ span: 6, offset: 3 }} className={styles.stepPosition}>
                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>1</div>
                            <div className={(step === 2) ? styles.stepActive : ''}>2</div>
                        </div>
                    </Col>


                    <Col sm={12} className="mb-5">
                        <Container>
                            <p className={styles.stepSubtopicName}>
                                {
                                    step === 1 ? 'Quiz Configuration'
                                        : 'Review'
                                }
                            </p>
                        </Container>
                    </Col>

                    <Col sm={12}>


                        {
                            isLoading === false ?
                                (<Container>
                                    {/* Rendering Content Goes Here */}
                                    {step === 1 && props.showModal === true && <QuizConfiguration nextPage={nextPage} setSubmitValues={setSubmitValues} values={values}
                                    />}
                                    {step === 2 && props.showModal === true && <Review nextPage={nextPage} previousPage={previousPage} handleClose={props.handleClose} refreshdata={props.refreshData} id={props.id}
                                        values={values}
                                    />}
                                </Container>)
                                : (<div>
                                    <Col sm={{ span: 4, offset: 4 }}>
                                        <CSSLoader />
                                    </Col>
                                </div>)
                        }
                    </Col>


                </Modal.Body>



            </Modal>

        </div >
    )
}
export default EditQuizTemplate;